import { useService } from "@policoders/di";
import { useEffect, useState } from "react";

import { UserModel } from "@modules/administration/pages/users/user.model";
import { UserRepository } from "@modules/administration/pages/users/user.repository";
import { ISelectOptions } from "@policoders/ds";
import { ACCESS_PROFILE, ACCESS_PROFILE_MODULES } from "@core/constants/modules.contants";

export type IUserFormProps = {
  data: UserModel;
  onChange: (data: UserModel) => void;
};

export const useUserForm = ({ data, onChange }: IUserFormProps) => {
  const [state, setState] = useState<UserModel>(data);
  const repository = useService<UserRepository>("UserRepository");

  useEffect(() => {
    data.id &&
      repository.getById(data.id).then(value => {
        setState(UserModel.build({ ...data, ...value }));
      });
  }, [data, repository]);

  useEffect(() => {
    onChange && onChange(state);
  }, [onChange, state]);

  const handleChange = (e: any) => {
    setState({ ...state, [e.target.name]: e.target.value });
  };

  const handleAccessChange = (e: any) => {
    setState({
      ...state,
      modules: {
        ...state.modules,
        [e.target.name]: e.target.value,
      },
    });
  };

  const accessOptions = (): ISelectOptions[] => {
    var items = Object.values(ACCESS_PROFILE);
    var values = Object.keys(ACCESS_PROFILE);
    return [
      { label: "-", value: "" },
      ...items.map((item, i) => ({
        label: item.replace("_", " "),
        value: values[i],
      })),
    ];
  };

  const accessModules = (): { label: string; value: string }[] => {
    var items = Object.values(ACCESS_PROFILE_MODULES);
    var values = Object.keys(ACCESS_PROFILE_MODULES);
    return [
      ...items.map((item, i) => ({
        label: item.replace("_", " "),
        value: values[i],
      })),
    ];
  };

  return { accessOptions, accessModules, state, handleChange, handleAccessChange };
};
